<template>
	<div id="process">
		<div class="process_img">
			<img src="../assets/fx_lc.png" alt="">
			<div class="process_btn" @click="download">下载APP</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Process',
	data () {
		return {

		}
	},
	created (){

	},
	methods:{
    download(){
      if(this.$store.state.config.jtype)
      {
        window.location.href = "https://apps.apple.com/cn/app/%E4%BA%91%E5%AD%A6%E5%91%98%E4%B8%80%E7%82%B9%E9%80%9A/id1503012554";
      }else{
        window.location.href = "https://yk.ioccn.com/template/default/index/download_tips.html";
      }
    }

	}
}
</script>
<style scoped>
	.process_img{
		background: #fff;
		height: 100vh;
		position: relative;
		overflow: hidden;
	}
	.process_img img{
		width: 100%;
		display: block;
		margin: 0 auto;
	}
	.process_btn{
		width: 70%;
		height: .88rem;
		color: #fff;
		background-color: #f2a943;
		position: absolute;
		left: 50%;
		transform: translateX(-50%);
		bottom: 1rem;
		border-radius: .44rem;
		text-align: center;
		line-height: .88rem;
		font-size: .24rem;
	}

</style>



// WEBPACK FOOTER //
// src/components/Process.vue